var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProLimitGraphics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 77,
    viewBox: "0 0 128 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9592 76.3294C99.2829 76.3294 127.918 74.4938 127.918 72.2296C127.918 69.9653 99.2829 68.1298 63.9592 68.1298C28.6355 68.1298 0 69.9653 0 72.2296C0 74.4938 28.6355 76.3294 63.9592 76.3294Z",
    fill: "#F5F9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 62.3331C85.6944 62.3331 89.5 58.5276 89.5 53.8331C89.5 49.1387 85.6944 45.3331 81 45.3331C76.3056 45.3331 72.5 49.1387 72.5 53.8331C72.5 58.5276 76.3056 62.3331 81 62.3331Z",
    fill: "#2772FF",
    stroke: "#2772FF",
    strokeWidth: 4.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81 22.6666C85.6944 22.6666 89.5 18.861 89.5 14.1666C89.5 9.47221 85.6944 5.66663 81 5.66663C76.3056 5.66663 72.5 9.47221 72.5 14.1666C72.5 18.861 76.3056 22.6666 81 22.6666Z",
    fill: "#2772FF",
    stroke: "#2772FF",
    strokeWidth: 4.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42.4999C51.6944 42.4999 55.5 38.6943 55.5 33.9999C55.5 29.3055 51.6944 25.4999 47 25.4999C42.3056 25.4999 38.5 29.3055 38.5 33.9999C38.5 38.6943 42.3056 42.4999 47 42.4999Z",
    fill: "#2772FF",
    stroke: "#2772FF",
    strokeWidth: 4.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9166 18.4166L54.0833 29.75",
    stroke: "#2772FF",
    strokeWidth: 4.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0833 38.2499L73.9166 49.5832",
    stroke: "#2772FF",
    strokeWidth: 4.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProLimitGraphics);
export default __webpack_public_path__ + "static/media/pro-limit-graphics.66338d56.svg";
export { ForwardRef as ReactComponent };